import React from "react";
const TargetLoading = () => {
  return <div> TargetLoading</div>;
};
export default TargetLoading;
